import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AnimatePresence } from '@sopranodesign/framer-motion';
import {
  Span,
  Button,
  Checkbox,
  Accordion,
  Explainer,
  InlineNotification
} from '@sopranodesign/pulse-components';

import FormGroup from './FormGroup';
import SettingContainer from './SettingContainer';
import { useTheme, useDelivery, useResetToken } from '../../hooks';

const ResetBot = () => {
  const [confirmed, setConfirmed] = useState(false);

  const { hasChannel } = useDelivery();

  const theme = useTheme();

  const { t } = useTranslation('bots');

  const { resetToken, isLoading, isSuccess } = useResetToken();

  const valid = hasChannel && !isLoading;

  return (
    <SettingContainer>
      <Accordion divider header={t('reset_setting_header')}>
        <FormGroup>
          <Explainer type="warning" hideLabel>
            <Span tinyText colour="black">
              {t('reset_setting_description')}
            </Span>
          </Explainer>
          <AnimatePresence>
            {isSuccess && (
              <InlineNotification
                description={t('reset_setting_success_notification')}
                type="success"
              />
            )}
          </AnimatePresence>
          {valid && (
            <Checkbox
              checked={confirmed}
              onChange={() => setConfirmed(!confirmed)}
              label={t('reset_setting_confirmation_message')}
              colour={theme.sentMessage?.background || theme.gradient.from}
            />
          )}
          <Button
            disabled={!valid || !confirmed}
            onClick={resetToken}
            custom_colour={theme.sentMessage?.background || theme.gradient.from}
            customTextColour={theme.sentMessage?.text || 'white'}
          >
            {t('reset_setting_submit_button')}
          </Button>
        </FormGroup>
      </Accordion>
    </SettingContainer>
  );
};

export default ResetBot;